import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { Logon } from "@serasa/core/modules/users/interfaces/logon.interface";

import {
  BlockUserPayload,
  UnblockUserPayload,
} from "../../interfaces/dashboard-state.interface";

// Block User

export const loadBlockUser = createAction(
  "[Dashboard] Load Block User",
  props<{ payload: BlockUserPayload }>(),
);

export const loadBlockUserSuccess = createAction(
  "[Dashboard] Load Block User Success",
  props<{ response: {} }>(),
);

export const loadBlockUserFailure = createAction(
  "[Dashboard] Load Block User Failure",
  props<{ error: HttpErrorResponse }>(),
);

// Unblock User

export const loadUnblockUser = createAction(
  "[Dashboard] Load Unblock User",
  props<{ payload: UnblockUserPayload }>(),
);

export const loadUnblockUserSuccess = createAction(
  "[Dashboard] Load Unblock User Success",
  props<{ response: {} }>(),
);

export const loadUnblockUserFailure = createAction(
  "[Dashboard] Load Unblock User Failure",
  props<{ error: HttpErrorResponse }>(),
);

// Reset

export const loadResetBlockUser = createAction(
  "[Dashboard] Load Reset Block User",
  props<{ selectedLogon: Partial<Logon | undefined> }>(),
);


// Delete User

export const loadDeleteUser = createAction(
  "[Dashboard] Load Delete User",
  props<{ logon: string | null }>(),
);

export const loadDeleteUserSuccess = createAction(
  "[Dashboard] Load Delete User Success",
  props<{ success: boolean }>(),
);

export const loadDeleteUserFailure = createAction(
  "[Dashboard] Load Delete User Failure",
  props<{ logon: string, error: HttpErrorResponse }>(),
);

export const loadResetErrorDeleteUser = createAction(
  "[Dashboard] Load Reset Error Delete User Failure"
);
